import { useState } from 'react'
import getMetrics from '../repository/getMetrics'
import Metrics from '../types/Metrics'
import useAlert from '@/components/Alert/hooks/useAlert'

const useMetrics = () => {
  const { alertError } = useAlert()
  const [metrics, setMetrics] = useState<Metrics | undefined>()

  const fetchMetrics = async () => {
    const result = await getMetrics()

    if (result.metrics) setMetrics(result.metrics)
    if (result.error) alertError(result.error)
  }

  return {
    metrics,
    fetchMetrics
  }
}

export default useMetrics
